module.exports = __webpack_public_path__ + "static/media/hero@2x.4f8ec0fb.jpg";